export enum ImageType {
    MenuGroup = "menuGroup",
    Main = "main",
    MenuItem = "menuItem",
    Avatar = "avatar",
}
